import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import ActivitiesLandingUtil from 'edge/gateway/util/activitieslanding/ActivitiesLandingUtil';

const fn = ($filter, $scope, $state, $stateParams, $window, InsuranceSuiteMetadata, ModalService, ActivityService, TranslateService) => {
    const ctrl = Object.create(BaseCtrl);

    $scope.loading = true;
    init();

    function init() {
        $scope.showAdvancedFilter = false;
        ActivitiesLandingUtil.initializeQuickFilters($scope);
        ActivitiesLandingUtil.initializeCustomFilters($scope);
        ActivitiesLandingUtil.translateFilters($scope, translateObjectDisplayKeys);
        $scope.showCRibbon = true;

        getActivitiesForCurrentUserAndGroups().then(
            (activities) => {
                $scope.allActivities = activities;
                createCustomFilterOptions(activities);
                ActivitiesLandingUtil.setQuickFilterActivityValues($scope);
                $scope.filterActivities($scope.currentQuickFilter);
                $scope.loading = false;
            },
            () => {
                $scope.loading = false;
            }
        );
    }

    function getActivitiesForCurrentUserAndGroups() {
        return ActivityService.getActivitiesForCurrentUserAndGroups();
    }

    $scope.filterActivities = (quickFilter) => {
        $scope.showCRibbon = (angular.isDefined(quickFilter) && quickFilter !== null) && quickFilter.name === 'createdByMeActivities';
        $scope.filteredActivities = $scope.getFilteredActivities(quickFilter);
    };

    $scope.getFilteredActivities = (quickFilter) => {
        if (quickFilter) {
            $scope.currentQuickFilter = quickFilter;
            ActivitiesLandingUtil.setCustomFilterFieldsForQuickFilter($scope, quickFilter);
            ActivitiesLandingUtil.setActiveQuickFilter($scope);
        }

        return $filter('filter')($scope.allActivities, filterActivity);
    };

    function filterActivity(activity) {
        let showActivity = true;
        if (angular.isDefined($scope.customFilter.filters)) {
            const selectedCustomFilters = _.filter($scope.customFilter.filters, (aFilter) => {
                return _.filter(aFilter.options, {
                    selected: true
                }).length > 0;
            });
            for (let i = 0; i < selectedCustomFilters.length; i++) {
                const customFilter = selectedCustomFilters[i];
                switch (customFilter) {
                    case $scope.activityStatusFilter:
                        showActivity = filterByCode($scope.activityStatusFilter, activity.status);
                        break;
                    case $scope.activityTypeFilter:
                        showActivity = filterByDisplayValue($scope.activityTypeFilter, activity.activityPattern.category.name);
                        break;
                    case $scope.activityPriorityFilter:
                        showActivity = filterByCode($scope.activityPriorityFilter, activity.priority);
                        break;
                    case $scope.activityAssignmentFilter:
                        showActivity = filterActivityByAssignment(activity);
                        break;
                    case $scope.activityCreatedByFilter:
                        showActivity = filterActivityByCreatedBy(activity);
                        break;
                    default:
                        showActivity = false;
                        break;
                }

                if (!showActivity) {
                    break;
                }
            }
        }

        return showActivity;
    }

    function filterByDisplayValue(filter, value) {
        return _.filter(filter.options, {
            selected: true,
            displayValue: value
        }).length > 0;
    }

    function filterByCode(filter, value) {
        return _.filter(filter.options, {
            selected: true,
            code: value
        }).length > 0;
    }

    function filterActivityByAssignment(activity) {
        let showActivity = false;
        const selectedOptions = _.filter($scope.activityAssignmentFilter.options, {
            selected: true
        });

        if (selectedOptions.length > 0) {
            for (let i = 0; i < selectedOptions.length; i++) {
                showActivity = selectedOptions[i].code === 'assignedToMe' ? activity.isAssignedToCurrentUser : !activity.isAssignedToCurrentUser;
                if (showActivity) {
                    break;
                }
            }
        }

        return showActivity;
    }

    function filterActivityByCreatedBy(activity) {
        let showActivity = false;
        const selectedOptions = _.filter($scope.activityCreatedByFilter.options, {
            selected: true
        });

        if (selectedOptions.length > 0) {
            for (let i = 0; i < selectedOptions.length; i++) {
                showActivity = selectedOptions[i].code === 'createdByMe' ? activity.isCreatedByCurrentUser : !activity.isCreatedByCurrentUser;
                if (showActivity) {
                    break;
                }
            }
        }

        return showActivity;
    }

    function createCustomFilterOptions(activities) {
        ActivitiesLandingUtil.createActivityPriorityFilterOptions($scope, InsuranceSuiteMetadata.get('pc').types.getTypelist('Priority'));
        activities.forEach((activity) => {
            ActivitiesLandingUtil.createActivityStatusFilterOptions($scope, activity);
            ActivitiesLandingUtil.createActivityTypeFilterOptions($scope, activity);
        });
    }

    $scope.setCustomFiltersSelected = (customFilter, value) => {
        ActivitiesLandingUtil.setCustomFiltersSelected(customFilter, value);
        $scope.filterActivities(null);
    };

    /**
     * Change the filter options when switching from quick to advanced filters
     * @param {*} shouldShow
     */
    $scope.switchFilterType = (shouldShow) => {
        $scope.showAdvancedFilter = shouldShow;
        if ($scope.showAdvancedFilter) {
            $scope.previousQuickFilter = $scope.currentQuickFilter;
            $scope.previousCustomFilter = $scope.customFilter;
            $scope.currentQuickFilter = null;
        } else {
            $scope.currentQuickFilter = $scope.previousQuickFilter;
            $scope.customFilter = $scope.previousCustomFilter;
        }

        $scope.filterActivities($scope.currentQuickFilter);
    };

    /**
     * Check if the advanced filter sub options should be shown
     * @param {Object} filter
     * @returns {Boolean} true if the sub options should be shown, otherwise false
     */
    $scope.showSubOptions = (filter) => {
        return filter.options.length > 0 && filter.selected;
    };

    /**
     * Translate the displayKeys of the given items and assign to item's displayValue property
     * @param {Array} items
     */
    function translateObjectDisplayKeys(items) {
        items.forEach((item) => {
            TranslateService.translate({
                object: item,
                propName: 'displayValue',
                displayKey: item.displayKey,
                scope: $scope
            });
        });
    }

    /**
     * Get a policy icon or a policy type.
     * @param {String} priority
     * @returns {String}
     */
    $scope.getPriorityIcon = (priority) => {
        return `../styles/images/icons/priorities/${priority}_16px.png`;
    };

    $scope.$on('activityCompleted', () => {
        ActivitiesLandingUtil.setQuickFilterActivityValues($scope);
        // $scope.filterActivities($scope.currentQuickFilter);
    });

    return ctrl.create($scope);
};

fn.$inject = ['$filter', '$scope', '$state', '$stateParams', '$window', 'InsuranceSuiteMetadata', 'ModalService', 'ActivityService', 'TranslateService'];
export default fn;